import type { Entity } from '@models/Entity'
import type { Page } from '@models/Query'
import type { SearchResults } from '@models/SearchResults'

import { apiClient } from '../../../gateways/api'
import type { HoofdnetOpdracht } from '../../../opdracht/hoofdnet/types/HoofdnetOpdracht'

export { fetchHoofdnetOpdrachtenForEntity, initialData }

const initialData = {
  items: [],
  count: 0,
  skip: 0,
  limit: 25,
}

const fetchHoofdnetOpdrachtenForEntity = async ({
  entity: { id },
  page,
}: {
  entity: Entity
  page: Page
}): Promise<SearchResults<HoofdnetOpdracht>> => {
  const { data } = await apiClient({
    url: '/rest/opdracht-hoofdnet/search',
    method: 'POST',
    data: {
      filters: [{ name: 'details.clusterId', value: id, operator: 'eq' }],
      ...page,
    },
  })

  return data
}
